import { takeEvery,takeLatest, fork, put, all, call } from 'redux-saga/effects';
import { FORGET_USER, RESET_PASSWORD_FORGOT, VALIDATE_RESET_TOKEN } from './actionTypes';
import { forgetUserSuccessful, resetPasswordFailed, resetPasswordSuccessful, userForgetPasswordError, validateResetTokenFailed, validateResetTokenSuccess } from './actions';
import { postForgetPwd, resetPasswordFrgt } from '../../helpers/auth_helper';

function* forgetUser({ payload: { user} }) {
    console.log("User in forget :: ", user)
        try {
            const response = yield call(postForgetPwd, {username: user.useremail});
            console.log("forgetUser response: ", response);
            if (response && response.status === 200) {
                yield put(forgetUserSuccessful("Email sent!"));
            } else {
                yield put(userForgetPasswordError({ message: response.data }));
            }
        } catch (error) {
            console.log("postForgetPwd called, received Error is :: ",error);
            if (error.response) {
                yield put(
                    userForgetPasswordError({
                        message: `${error.response.data}`,
                    })
                );
            } else if (error.request) {
                yield put(
                    userForgetPasswordError({
                        message: "No response received",
                    })
                );
            } else {
                yield put(
                    userForgetPasswordError({ message: error.message })
                );
            }
        }
}

function* resetPassword(action) {
    try {
        console.log("Reset Password :: ", action.payload.resetDTO);
        const response = yield call(resetPasswordFrgt, action.payload.resetDTO);
        console.log("resetPassword response: ", response);
        if (response && response.status === 200) {
            yield put(resetPasswordSuccessful("Password reset successfully!"));
        } else {
            yield put(resetPasswordFailed({ message: response.data }));
        }
    } catch (error) {
        console.log("resetPasswordFrgt called, received Error is :: ", error);
        if (error.response) {
            yield put(
                resetPasswordFailed({
                    message: `${error.response.data}`,
                })
            );
        } else if (error.request) {
            yield put(
                resetPasswordFailed({
                    message: "No response received",
                })
            );
        } else {
            yield put(
                resetPasswordFailed({ message: error.message })
            );
        }
    }
}


export function* watchUserForget() {
    yield takeEvery(FORGET_USER, forgetUser)
    
}

// export function* watchValidateReset(){
//     yield takeLatest(VALIDATE_RESET_TOKEN, validateReset)
// }
export function* watchResetFrgt(){
    yield takeLatest(RESET_PASSWORD_FORGOT, resetPassword)
}
function* forgetSaga() {
    yield all([fork(watchUserForget)]);
    // yield all([fork(watchValidateReset)]);
    yield all([fork(watchResetFrgt)]);
}

export default forgetSaga;